import Link from 'next/link';

type Props = {
   href: string;
   text: string;
   className: string;
   openInNewTab?: boolean;
};

const StyledLink = ({ href, text, openInNewTab, className }: Props) => (
   <Link href={href}>
      <a
         className={className}
         {...(openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
         {text}
      </a>
   </Link>
);

export default StyledLink;
